import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import dangerIcon from '../../../assets/images/SVG/dangerIcon.svg';

const CancelExamModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
      disableScrollLock
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(15, 23, 42, 0.4)',
          backdropFilter: 'blur(8px)',
        },
        '& .MuiPaper-root': {
          borderRadius: '24px !important',
          width: '100%',
          maxWidth: '400px',
          margin: '16px',
          boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          fontFamily: "'Poppins', sans-serif",
          overflow: 'visible',
          position: 'relative',
          p: { xs: 3, sm: 4 },
          pt: { xs: 4, sm: 5 }
        }
      }}
    >
      <DialogContent sx={{ p: 0, textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Centered Warning Icon SVG */}
          <Box
            component="img"
            src={dangerIcon}
            alt="Warning"
            sx={{
              width: '90px',
              height: '90px',
              mb: 3,
              filter: 'drop-shadow(0 8px 16px rgba(204, 70, 70, 0.15))'
            }}
          />

          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 750,
              color: '#1e293b',
              mb: 2,
              fontSize: { xs: '20px', sm: '22px' },
              fontFamily: "'Poppins', sans-serif"
            }}
          >
            Cancel Quiz !
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: '13.5px',
              color: '#64748b',
              fontFamily: "'Poppins', sans-serif",
              lineHeight: 1.5,
              mb: 4,
              px: 2
            }}
          >
            Are you sure you want to cancel this quiz? If you cancel, your progress will not be saved.
          </Typography>

          {/* Control Buttons */}
          <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'center' }}>
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                flex: 1,
                borderRadius: '9999px',
                py: 1.5,
                fontSize: '15px',
                fontWeight: 700,
                textTransform: 'none',
                fontFamily: "'Poppins', sans-serif",
                borderColor: '#CC4646',
                color: '#CC4646',
                borderWidth: '1.5px',
                '&:hover': {
                  borderColor: '#9c1717',
                  bgcolor: 'rgba(204, 70, 70, 0.05)',
                  borderWidth: '1.5px'
                }
              }}
            >
              No
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{
                flex: 1,
                background: 'linear-gradient(135deg, #CC4646 0%, #9C1717 100%)',
                color: '#ffffff',
                borderRadius: '9999px',
                py: 1.5,
                fontSize: '15px',
                fontWeight: 700,
                textTransform: 'none',
                fontFamily: "'Poppins', sans-serif",
                '&:hover': {
                  background: 'linear-gradient(135deg, #e05c5c 0%, #b32424 100%)',
                },
                '&:active': {
                  transform: 'translateY(0)'
                },
                transition: 'all 0.25s ease'
              }}
            >
              Yes
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelExamModal;
